import * as Sentry from '@sentry/react-native';
import { ENV } from '@/config/env';

// @sentry/react-native supports react-native-web, so this single module serves
// both the native and web root layouts — no .web.ts split needed. Browser-only
// integrations are added automatically when running on web.
export function initSentry() {
    Sentry.init({
        dsn: ENV.SENTRY_DSN,
        environment: __DEV__ ? 'development' : 'production',
        // Full tracing in dev; 10% in production to stay within Sentry quota.
        tracesSampleRate: __DEV__ ? 1.0 : 0.1,
        ignoreErrors: [
            // livekit-client NegotiationError: a benign teardown race on web —
            // hanging up / closing the call window while a WebRTC negotiation
            // is in flight rejects an internal promise after the peer
            // connection manager is closed. Not catchable from app code
            // (surfaces as an unhandled rejection inside the LiveKit engine).
            'PC manager is closed',
        ],
    });
}

export { Sentry };
